define([], function() {
  function changeLesson() {
    $('[data-behavior~=lessons_dropdown]').each(function() {
      $(this).change(function() {
        const selectedLesson = this.value;

        const url = $(this).parent().attr('data-resource-url');

        location.href = url.replace('id_js_swap', selectedLesson);
      });
    });
  }

  return {
    init: function() {
      changeLesson();
    }
  };
});
